$(document).ready(function(){

     $(window).scroll(function() {
       var scroll = $(window).scrollTop();
       //>=, not <=
       if (scroll >= 2) {
           //clearHeader, not clearheader - caps H
           $(".mobile-filters ").addClass("stickiy-filter");
       } else {
           $(".mobile-filters ").removeClass("stickiy-filter");
       }
     }); 

      
     // On clicking the rotate-icon
     $(document).on('click', 'span.roatate-icon', function() {
         // console.log('rotate-icon clicked');
         $('.product-meta').fadeOut(); // Hide all product-meta elements
         //$('span.rotate-icon').removeClass('rotate');
         $('span.roatate-icon').removeClass('rotate');
         $(this).addClass('rotate');
         $(this).parents('.icon-with-title').find('.product-meta').fadeIn(); // Show the clicked one
     });

     // On clicking a rotated icon to hide its related product-meta
     $(document).on('click', 'span.rotate', function() {
         console.log('rotate clicked');
         $(this).parents('.icon-with-title').find('.product-meta').fadeOut();
         $(this).removeClass('rotate');
     });

     // Hide product-meta elements when clicking outside of them
     $(document).click(function(event) {
         if (!$(event.target).closest('.product-meta, span.roatate-icon').length) {
             $('.product-meta').fadeOut();
             $('span.roatate-icon').removeClass('rotate');
         }
     });

     // Announcement bar slider only for mobile view
     $('.custom-slides').slick({
         infinite: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         autoplaySpeed: 5000,
         arrows: true,
         nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
         prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>'
     });
     $('.custom-slides').css('opacity', 1);
     // Announcement bar slider only for mobile view
     if ($(window).width() <= 767) {
         $('.images-boxes').slick({
             infinite: true,
             dots: true,
             slidesToShow: 1,
             slidesToScroll: 1,
             nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
             prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>'
         });
     }

     $('.desktop-slide-section').show();


     if (window.innerWidth < 768) {
         $('.bbs-slide').slick({
             infinite: true,
             dots: true,
             slidesToShow: 5,
             slidesToScroll: 1,
             nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
             prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
             responsive: [{
                 breakpoint: 600,
                 settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1,
                     dots: false,
                     arrows: true,
                 }
             }]
         });
     }

     var header = $('.header');
     var bodiy = $('body');
     $(window).scroll(function() {
         // Check if user has scrolled down 50px from the top
         if ($(this).scrollTop() > 50) {
             header.addClass('stuck');
             bodiy.addClass('stickybar-body');
         } else {
             header.removeClass('stuck');
             bodiy.addClass('stickybar-body');
         }
     });

   $('#grid-view-btn').addClass('active');
   $('.collection__products.collection__infinite-container').removeClass('list-view-wrap').addClass('grid-view-wrap');
   // Handle Grid View button click
   $('#grid-view-btn').on('click', function(event) {

       event.preventDefault(); // Prevent page refresh

       // Switch to Grid View and save the preference
       $('.collection__products.collection__infinite-container').removeClass('list-view-wrap').addClass('grid-view-wrap');
       localStorage.setItem('viewPreference', 'grid-view-wrap');
   });

   // Handle List View button click
   $('#list-view-btn').on('click', function(event) {
       event.preventDefault(); // Prevent page refresh

       // Switch to List View and save the preference
       $('.collection__products.collection__infinite-container').removeClass('grid-view-wrap').addClass('list-view-wrap');
       localStorage.setItem('viewPreference', 'list-view-wrap');
   });


   $('.view-toggle button').click(function() {
       $('.view-toggle button').removeClass('active');
       $(this).addClass('active');
   });


   jQuery(document).on('mouseenter', 'span.custom-quick-image', function() {
       var imageSrc = $(this).data('img');
       $(this).parents('.quick-search__result').find('.quick-search__result-image-wrapper img').attr('src', imageSrc);
       $(this).parents('.quick-search__result').find('.quick-search__result-image-wrapper img').attr('srcset', imageSrc);
   });

   jQuery(document).on('click', 'span.custom-quick-search', function() {
       var imageSrc = $(this).data('img');
       $(this).parents('.product-item__inner').find('.image img').attr('src', imageSrc);
       $(this).parents('.product-item__inner').find('.image img').attr('srcset', imageSrc);
   });
  
   $('ul.filter-drawer__list').each(function() {
       var $list = $(this);
       var $items = $list.find('li');

       if ($items.length > 4) {
           $items.slice(3).hide().addClass('toggleable');
           $list.append('<li class="more">Show More..</li>');
       }
   });

   // Click event for "More..." and "Less..." buttons
   $('ul.filter-drawer__list').on('click', '.more, .less', function() {
       var $this = $(this);
       var $list = $this.closest('ul.filter-drawer__list');
       var $toggleableItems = $list.find('li.toggleable');

       if ($this.hasClass('more')) {
           $this.text('Show Less..').removeClass('more').addClass('less');
       } else {
           $this.text('Show More..').removeClass('less').addClass('more');
       }

       // Toggle the visibility of the toggleable items
       $toggleableItems.slideToggle('fast', function() {
           // Update visibility of the "More..." and "Less..." buttons
           if ($this.hasClass('less')) {
               $this.siblings('.more').hide();
           } else {
               $this.siblings('.less').hide();
           }
           $this.show(); // Ensure the current button is visible
       });
   });
  
  $(".product-rating.customscroll").click(function(e) {
    e.preventDefault();
    let headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--height-header').trim(); 
    headerHeight = parseInt(headerHeight) || 0;
    $('html, body').animate({
        scrollTop: $('[data-section-type="apps"]').offset().top - headerHeight
    }, 'slow');
  });
  
});